/**
 * Bass macro constants — shared between sampleBank.js (renders the audio)
 * and customBassVoices.js (clamps on save). Lives in its own file to avoid
 * a circular import.
 */

export const BASS_MACRO_SCHEMA = {
  decay:  [0.3, 3.0],
  drive:  [0.3, 3.0],
  subMix: [0.0, 1.0],
  pitch:  [-24, 24],
};

export const BASS_MACRO_DEFAULTS = {
  decay: 1.0, drive: 1.0, subMix: 0.0, pitch: 0,
};

/** Display labels + readable units for the macro sliders. */
export const BASS_MACRO_LABELS = {
  decay:  { label: "Decay",    unit: (v) => `${v.toFixed(2)}×` },
  drive:  { label: "Drive",    unit: (v) => `${v.toFixed(2)}×` },
  subMix: { label: "Sub Mix",  unit: (v) => `${Math.round(v * 100)}%` },
  pitch:  { label: "Pitch",    unit: (v) => `${v > 0 ? "+" : ""}${v} st` },
};

/** Clamp + fill missing keys from defaults. Used by both layers. */
export function clampBassMacros(input) {
  const out = {};
  for (const k of Object.keys(BASS_MACRO_SCHEMA)) {
    const [min, max] = BASS_MACRO_SCHEMA[k];
    const v = (input && typeof input[k] === "number") ? input[k] : BASS_MACRO_DEFAULTS[k];
    out[k] = Math.max(min, Math.min(max, v));
  }
  return out;
}
